import throttle from '@plugins/throttle';

export default class PersistentSignUp {

  constructor() {
    // Breakpoint width
    this.widthBreakpoint = 1000;
    this.heightBreakpoint = 600;
    // 1000 * 60 * 60 * 24
    this.millisecondsPerDay = 86400000;
    this.localStorageId = 'aauw-persistent-sign-up-rest-until';
    this.$element = null;
    this.$footer = null;
    this.initialized = false;
    this.hidden = true;
    this.resting = false;

    // Specify method that popup management should call
    this.popupManagementCall = this.display;
  }

  display(hasPopped) {
    // hasPopped is passed from the pop-up manager to indicate whether there has
    // been a popup yet since page load. If there has, we do not want to throw
    // the persistent signup element in during the same page load.
    if (hasPopped) {
      return false;
    }

    // If initialization has already happened, just return a boolean to indicate
    // state.
    if (this.resting) {
      return false;
    }

    if (this.initialized) {
      return true;
    }

    // Check if the element is "resting" and should not be shown to the user
    // again yet.
    const restExpireTime = localStorage.getItem(this.localStorageId),
          now = Date.now()
    ;
    if (restExpireTime) {
      // 0 means that the modal should never be shown again
      if (restExpireTime === '0' || restExpireTime > now) {
        this.resting = true;
        return false;
      } else {
        // The rest period has expired, so we will show the element.
        // Delete the current rest entry.
        localStorage.removeItem(this.localStorageId);
      }
    }

    this.$footer = $('.site-footer-sign-up');
    this.$element = $('#persistent-sign-up');

    if (!this.$element.length || !this.$footer.length) {
      return false;
    }

    this.$element.find('.persistent-sign-up-close').on('click', () => {
      this.closeElement();
    });

    // On email success subscribe, visually hide the heading and set infinite
    // element rest period.
    this.$element.on('aauw-email-signup-success', () => {
      this.$element.find('.persistent-sign-up-title').addClass('sr-text');
      localStorage.setItem(this.localStorageId, '0');
    });

    // Turn display on and force browser to run layout
    this.$element.css('display', '').height();

    $(window).on('scroll resize', throttle(
      () => {
        this.scrollCalcs();
      }, 200)
    );

    // We may need to hide the element suddenly if the user focuses on the
    // footer
    $(document).on('focusin', () => {
      this.scrollCalcs();
    });

    // We may need to hide the element suddenly if the user focuses outside the
    // element while in certain scroll positions
    this.$element.on('focusout', () => {
      this.scrollCalcs();
    });

    this.initialized = true;

    this.scrollCalcs();

    return true;
  }

  /**
   * Hide the element permanently - it will not show again until a different
   * page load.
   */
  closeElement() {
    // Don't show the persistent sign-up again for 14 days.
    // But - don't overwrite an infinite rest period from submission.
    if (localStorage.getItem(this.localStorageId) !== '0') {
      const now = Date.now();
      // now + 14 days, AKA now + (1000 * 60 * 60 * 24 * 14)
      localStorage.setItem(this.localStorageId, now + 1209600000);
    }

    this.resting = true;
    this.hideElement();

    this.$element.trigger('aauw-popup-closed');
  }

  hideElement() {
    if (!this.hidden) {
      this.$element.css({
        'visibility': 'hidden',
        'transform': ''
      });
      this.hidden = true;
    }
  }

  showElement() {
    if (!this.resting && this.hidden) {
      // Force layout to run after turning off visibility, so that CSS transform
      // will take effect
      this.$element.css('visibility', '').height();
      this.$element.css('transform', 'translateY(0)');
      this.hidden = false;
    }
  }

  /* eslint-disable operator-linebreak */
  /**
   * Calculate whether element should be shown or hidden based on scroll
   * position.
   */
  scrollCalcs() {
    const $window = $(window);
    if (this.resting || this.widthBreakpoint > $window.width() || this.heightBreakpoint > $window.height()) {
      return;
    }

    const $focusedElement = $(':focus');

    // Always keep showing if keyboard focus is inside the element
    if ($focusedElement.parents('#persistent-sign-up').length) {
      return;
    }

    // Never show if keyboard focus is inside the footer
    if ($focusedElement.parents('.site-footer').length) {
      this.hideElement();
      return;
    }

    // Show once the user has scrolled at least a little bit,
    const shortestOffsetShown = 120,
          // and stop showing at a bottom extent once user scrolls the last pane
          // of the footer into the window.
          farthestOffsetShown = $(document).height() - $window.height() - this.$footer.innerHeight()
    ;

    if (
      this.hidden
      && farthestOffsetShown > window.scrollY
      && window.scrollY > shortestOffsetShown
    ) {
      this.showElement();
    } else if (
      !this.hidden
      && (
        shortestOffsetShown > window.scrollY
        || window.scrollY > farthestOffsetShown
      )
    ) {
      this.hideElement();
    }
  }
  /* eslint-enable operator-linebreak */

}
